import React, { useState, useEffect } from "react";
import AccountList from "../accountList/AccountList";
import Select from "react-select";
import { connect } from "react-redux";
import { Popup } from "semantic-ui-react";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

import { Checkbox, Icon } from "semantic-ui-react";
import axios from "axios";
import { ReactComponent as SearchIcon } from "../../../../../assets/svg/search.svg";
import { ReactComponent as CaneclIcon } from "../../../../../assets/svg/close.svg";

import "../PlatformConfig.scss";
import { gettingStartedProgress } from "../../../../../actions/globalAction";
import { getYoutubeChannelId } from "../../../../../actions/queryBuilderActions";
import { toast } from "react-toastify";

function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

const changeTwitterName = (currentName) => {
    if (currentName === "twitter") {
        return "X";
    }
};

function AdditionalDataOtherPlatforms(props) {
    const [youtubeChannelLoading, setYoutubeLoading] = useState(false);

    useEffect(() => {
        if (
            props.validAccounts &&
            props.validAccounts[0]?.account_exist &&
            (props.validAccounts[0]?.details[0]?.name.toLowerCase() === props.accountName?.toLowerCase() ||
                props.validAccounts[0]?.details[0]?.account_id?.toLowerCase() === props.accountName?.toLowerCase())
        ) {
            let country;
            let entity;
            if (props.validAccounts[0].details[0].country_id)
                country = props.getCountryList().find((val) => val.value === props.validAccounts[0].details[0].country_id);
            if (props.validAccounts[0].details[0].entity_sub_type)
                entity = props.entityList.find((val) => val.value === props.validAccounts[0].details[0].entity_sub_type);

            props.setValidCountry(country);
            props.setValidEntity(entity);
        }
    }, [props.validAccounts]);

    useEffect(() => {
        props.setValidCountry(null);
    }, [props.location]);

    useEffect(() => {
        props.setValidEntity(null);
    }, [props.entityType]);

    let accountLabel = "Account Name*";
    let placeholder = "Enter Account name";

    if (props.platformName === "pinterest") {
        accountLabel = "Account URL*";
        placeholder = "Enter Account URL";
    } else if (props.platformName === "youtube") {
        accountLabel = "Channel URL*";
        placeholder = "Enter Channel URL";
    }

    const verifyAccount = () => {
        if (props.verifyingAccount || youtubeChannelLoading) return;

        if (props.platformName !== "youtube") {
            props.verifyAccount();
        } else {
            setYoutubeLoading(true);
            props
                .getYoutubeChannelId({ url: props.yTAccountURL })
                .then((res) => {
                    setYoutubeLoading(false);
                    if (res.action?.payload?.status) {
                        let url = res.action.payload.channelId.split("/");
                        props.handleUrlChange({ target: { value: url[url.length - 1] } });
                        props.verifyAccount(false, url[url.length - 1]);
                    } else {
                        toast.error("Channel not found");
                    }
                })
                .catch((err) => {
                    setYoutubeLoading(false);
                });
        }
    };

    return (
        <div className="additionalDataInstagram">
            <section className="parentSection">
                <div className="addAccountBlock">
                    <div className="authenticateSection">
                        <section className="leftSection">
                            <Popup
                                inverted
                                content={
                                    props.platformName === "forum"
                                        ? "Forums"
                                        : props.platformName === "twitter"
                                        ? changeTwitterName(props.platformName)
                                        : capitalize(props.platformName)
                                }
                                //content={props.platformName === "forum" ? "Forums" : capitalize(props.platformName)}
                                trigger={
                                    <div>
                                        <img src={props.icon} className="platformIcon" alt="platform icon" />
                                    </div>
                                }
                            />
                        </section>
                        <div onClick={props.closeComponent}>
                            <button className="common__btn ml-1 backButton">Back to Social Accounts</button>
                        </div>
                    </div>

                    <section className="add_account-form">
                        <div className="field__row m-10">
                            {props.platformName === "youtube" && (
                                <div className="field__wrap">
                                    <label>Channel URL</label>
                                    <input
                                        type="text"
                                        className="add__input youtube"
                                        placeholder={`https://www.youtube.com/c/mkbhd`}
                                        value={props.yTAccountURL}
                                        onChange={(e) => props.handleChUrlChange(e)}
                                    />
                                </div>
                            )}
                            {props.platformName !== "youtube" && (
                                <div className="field__wrap">
                                    <label>{accountLabel}</label>
                                    <input
                                        type="text"
                                        className="add__input"
                                        placeholder={placeholder}
                                        value={props.accountName}
                                        onChange={(e) => props.handleUrlChange(e)}
                                    />
                                </div>
                            )}

                            {props.isAccountValid && (
                                <>
                                    <div className="field__wrap">
                                        <label>Location</label>
                                        <Select
                                            className="platform-list"
                                            value={props.validCountry || props.location}
                                            isSearchable
                                            placeholder="Select Location"
                                            options={props.getCountryList()}
                                            onChange={props.handleLocationChange}
                                            formatOptionLabel={props.formatOptionLabel}
                                            maxMenuHeight={140}
                                            styles={props.customStyle}
                                            isClearable
                                            components={{ IndicatorSeparator: () => null }}
                                        />
                                    </div>
                                    <div className="field__wrap">
                                        <label>Entity Type</label>
                                        <Select
                                            className="platform-list"
                                            value={props.validEntity || props.entityType}
                                            isSearchable
                                            placeholder="Select Entity Type"
                                            options={props.entityList}
                                            onChange={props.handleEntityTypeChange}
                                            maxMenuHeight={140}
                                            styles={props.customStyle}
                                            isClearable
                                            components={{ IndicatorSeparator: () => null }}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </section>

                    <div className="field__row-normal m-20">
                        <Checkbox className="mr-10" checked={props.isPublication} onChange={() => props.setPublication()} />
                        <p>Please Select if this is a News Publication (Eg. Wall Street Journal Facebook Page, Wall Street Journal Blog Etc).</p>
                    </div>

                    {props.platformName === "youtube" && (
                        <div className="field__row-normal m-10">
                            <Checkbox className="mr-10" checked={props.fetchComment} onChange={() => props.setPullComments()} />
                            <p>Pull Comments.</p>
                        </div>
                    )}

                    <div className="field__row-normal m-20">
                        <button className="common__btn offset-hieight" onClick={verifyAccount}>
                            <span> {props.verifyingAccount || youtubeChannelLoading ? <Loader active size="small" /> : ""} Verify </span>
                        </button>
                        <p className="ml-1">*Validate to continue account Configuration</p>

                        <button className="common__btn ml-10 offset-hieight" disabled={!props.isAccountValid} onClick={() => props.onAddAccount()}>
                            <span> {props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                        </button>
                    </div>

                    <section className="account__list-table">
                        <AccountList
                            isAccountAdded={props.isAccountAdded}
                            accountListData={props.accountListData}
                            deleteAccount={props.deleteAccount}
                            allLocations={props.allLocations}
                        />
                    </section>
                </div>
                <div className="saveAndContinue">
                    <button className="common__btn" disabled={props.accountListData.length === 0} onClick={props.closeComponent}>
                        Save and continue
                    </button>
                </div>
            </section>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        getYoutubeChannelId: (d) => dispatch(getYoutubeChannelId(d)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDataOtherPlatforms);
